<template>
  <BaseTemplate :currentUser="currentUser">
    <div class="fund-settlement">
      <Title jpn="基於《支付服務法》的描述" />
      <div class="scroll-container">
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">營運公司名稱</span>
            <span class="text">零地有限公司</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">代表人</span>
            <span class="text">成田由紀</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">公司註冊地址/營業辦公地址</span>
            <span class="text">〒330-0854</span>
            <span class="text">埼玉縣埼玉市大宮區櫻木町1丁目195‑1</span>
            <span class="text">大宮SORAMICHI KOZ4樓</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container left">
            <span class="text">硬幣（本網站上的貨幣）所有權限制/期限</span>
            <span class="text">硬幣沒有上限。</span>
            <span class="text">但是，如果在購買或兌換金幣後，自上次使用金幣起超過 6 個月（包括當日）仍未使用金幣，我們可能會在不提前通知您的情況下刪除您的帳戶。</span>
            <span class="text">在這種情況下，硬幣將失效。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container left">
            <span class="text">硬幣使用地點範圍</span>
            <span class="text">硬幣沒有上限。</span>
            <span class="text">硬幣（本網站內的貨幣）可以在註冊帳戶內使用。</span>
            <span class="text">此外，禁止帳戶轉讓和硬幣轉讓。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container left">
            <span class="text">使用注意事項</span>
            <span class="text">硬幣（本網站內的貨幣）無法退款。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container left">
            <span class="text">如何查看自己擁有的金幣</span>
            <span class="text">您可以在本網站的螢幕上查看。</span>
            <span class="text">如果您擁有的金幣有任何變動，金幣的數量將會自動改變。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container left">
            <span class="text">聯絡資訊</span>
            <span class="text">請在這裡聯絡我們。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">服務條款</span>
            <span class="text">請檢查本網站的使用條款。</span>
          </div>
        </ShadowBoxTitleDescription>
      </div>
    </div>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import ShadowBoxTitleDescription from '@/components/molecules/ShadowBoxTitleDescription.vue';
import Title from '@/components/molecules/Title02.vue';
import t from '@/plugins/i18n';

export default {
  name: 'FundSettlement',
  mixins: [t],

  components: {
    BaseTemplate,
    ShadowBoxTitleDescription,
    Title,
  },

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
    }),
  },

  created() {
    this.$store.dispatch('user/setCurrentUser', { token: 'yugi' });
  },
};
</script>

<style lang="scss" scoped>
.fund-settlement{
  width: 100%;
  max-width: 1000px;
  min-height: 100%;
  padding: 30px 20px 0px;
  margin: 0px auto;
  .fund-settlement-title{
    display: flex;
    justify-content: center;
    .text{
      height: 35px;
      font-family: $notoSerif;
      font-size: 24px;
      font-weight: 700;
    }
  }
  .scroll-container{
    width: 100%;
    margin-top: 30px;
    padding-bottom: 50px;
    max-width: 1000px;
    margin-left: auto;
    margin-right: auto;
    .shadow-box-title-description{
      width: 100%;
      .text-container{
        display: flex;
        flex-direction: column;
        padding: 5px 5px 0px 5px;
        .text{
          font-family: $notoSans;
          font-size: 13px;
          line-height: 1.5;
          letter-spacing: 0.03em;
          a {
            color: $blue!important;
          }
          &.margin-top{
            margin-top: 10px;
          }
          &.one-line-space-top{
            margin-top: 1em;
          }
        }
      }
      & + .shadow-box-title-description{
        margin-top: 40px;
      }
    }
  }
}
@media screen and  (max-width: $tabletWidth) {
  .left {
    text-align: left!important;
  }
}
</style>
